import React from 'react';
import { useQueryClient } from 'react-query';
import {Select, MenuItem, InputLabel} from '@material-ui/core';
import { useEnquiryCostings } from "../../../services/enquiry";
import __ from "lodash";
import moment from 'moment';

const EnquiryCostingSelector = props => {
  const queryClient = useQueryClient();
  const extraKeys = [props.enquiryUuid];
  const records = useEnquiryCostings({queryClient, useCache: false, extraKeys});
  const style = props.style || {};
  const id = props.id;
  const label = props.label;
  const readOnly = props.readOnly || false;
  const fullWidth = props.fullWidth || false;

  const classNames = [props.className];
  if (props.readOnly) {
    classNames.push('readOnly');
  }
  const className = classNames.join(" ");

  const handleChange = event => {
    if (props.returnType === "object") {
      const returnObject = { value: event.target.value, found: false, data: {}}
      const data = __.find(records.data, { costingUuid: event.target.value });
      if (data) {
        returnObject.found = true;
        returnObject.data = data;
      }
      props.onChange(returnObject);
    } else {
      props.onChange(event.target.value);
    }
  }

  return (
    <div>
      {label?
        <InputLabel shrink id={`${id}-label`} style={{...style}}>{label}</InputLabel>
        :<></>
      }
      <Select
        style={{...style}}
        readOnly={readOnly}
        className={className}
        value={props.value == null?'':props.value}
        fullWidth={fullWidth}
        onChange={handleChange}
        renderValue={(costingUuid) => {
          let value = costingUuid;
          const costing = __.find(records.data, {costingUuid: costingUuid});
          if (costing) {
            value = `UCN-${costing.costingNumber}`;
          }
          return value;
        }}
      >
        {(records.data) ?
          records.data.filter(currency => !currency.childCurrency).map((record) => {
            return (
              <MenuItem key={record.costingUuid} value={record.costingUuid}>UCN-{record.costingNumber} {moment(record.costingDate).format("DD MMM")} - {record.tripRouting}</MenuItem>
            );
          }) :
          null
        }
      </Select>
    </div>
  )
}

export default EnquiryCostingSelector;
